var React = require('react');

function MediumLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.6062 2.82063L30 0.506526V0H21.7075L15.7975 14.8648L9.07375 0H0.37875V0.506526L3.175 3.90821C3.4475 4.15958 3.59 4.52716 3.55375 4.89726V18.2653C3.64 18.7465 3.485 19.2417 3.15 19.5916L0 23.4493V23.9495H8.93125V23.4429L5.78125 19.5916C5.44 19.2404 5.27875 18.7541 5.3475 18.2653V6.70232L13.1875 23.9558H14.0988L20.84 6.70232V20.4467C20.84 20.8093 20.84 20.8838 20.605 21.1213L18.18 23.4922V24H29.945V23.4935L27.6075 21.1806C27.4025 21.024 27.2962 20.7613 27.34 20.5061V3.49516C27.2962 3.23874 27.4012 2.976 27.6062 2.82063Z","fill":"#318eff"}));
}

MediumLogo.defaultProps = {"width":"30","height":"24","viewBox":"0 0 30 24","fill":"none"};

module.exports = MediumLogo;

MediumLogo.default = MediumLogo;
